var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVkontakte(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7903_98972)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.859375,
    width: 23.715,
    height: 23.715,
    rx: 4.08879,
    fill: "#6563FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.9211,
    cy: 11.8574,
    rx: 9.60864,
    ry: 10.6308,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3403 -0.0683594H9.0234C2.34006 -0.0683594 0.75 1.5217 0.75 8.19259V15.5095C0.75 22.1928 2.32769 23.7829 9.01095 23.7829H16.3278C23.0112 23.7829 24.6012 22.2052 24.6012 15.5219V8.20504C24.6012 1.5217 23.0236 -0.0683594 16.3403 -0.0683594ZM20.0049 16.9505H18.2658C17.6074 16.9505 17.4086 16.4163 16.2285 15.2362C15.1974 14.2424 14.7626 14.1181 14.5017 14.1181C14.1415 14.1181 14.0421 14.2175 14.0421 14.7144V16.2797C14.0421 16.702 13.9055 16.9505 12.7999 16.9505C11.727 16.8784 10.6867 16.5525 9.76444 15.9996C8.84222 15.4467 8.06453 14.6826 7.49543 13.7703C6.14438 12.0887 5.20435 10.115 4.75008 8.00625C4.75008 7.74538 4.84943 7.50934 5.34636 7.50934H7.08549C7.5327 7.50934 7.69422 7.70811 7.86811 8.16777C8.71281 10.6523 10.1539 12.8138 10.7377 12.8138C10.9613 12.8138 11.0607 12.7144 11.0607 12.1554V9.59632C10.9861 8.42865 10.365 8.32922 10.365 7.9069C10.3732 7.79548 10.4245 7.69163 10.508 7.6174C10.5915 7.54317 10.7006 7.50441 10.8122 7.50934H13.5452C13.9179 7.50934 14.0421 7.69567 14.0421 8.14289V11.5964C14.0421 11.9691 14.2036 12.0932 14.3154 12.0932C14.539 12.0932 14.7129 11.9691 15.1228 11.5591C16.0038 10.4848 16.7236 9.28799 17.2595 8.00625C17.3142 7.85203 17.4179 7.71995 17.5548 7.63022C17.6916 7.54049 17.8541 7.49803 18.0173 7.50934H19.7565C20.2782 7.50934 20.39 7.77021 20.2782 8.14289C19.6454 9.56002 18.8625 10.9052 17.9428 12.1554C17.7565 12.4411 17.6819 12.5902 17.9428 12.9256C18.1167 13.1864 18.7254 13.6958 19.1354 14.1802C19.7316 14.775 20.2267 15.4632 20.6012 16.2176C20.7502 16.702 20.5018 16.9505 20.0049 16.9505Z",
    fill: "#6563FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7903_98972"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.859375,
    width: 23.715,
    height: 23.715,
    rx: 4.08879,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkontakte);
export default __webpack_public_path__ + "static/media/vkontakte.43c996a8db6610d087a3e43fdbfde9ed.svg";
export { ForwardRef as ReactComponent };